import { render, staticRenderFns } from "./SimpleItem.vue?vue&type=template&id=485ceb7e&"
import script from "./SimpleItem.vue?vue&type=script&lang=ts&"
export * from "./SimpleItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports